import camelcaseKeys from 'camelcase-keys'

import { handleFetch } from '@src/utils/fetch'

class LocalStoragePrefixes {
  #datasetUrlPrefix = $state('')
  #modelCodeUrlPrefix = $state('')

  get datasetUrlPrefix() {
    return this.#datasetUrlPrefix
  }

  get modelCodeUrlPrefix() {
    return this.#modelCodeUrlPrefix
  }

  async getPrefixesFromServer() {
    const response = await handleFetch('/local-storage/')
    const data = camelcaseKeys(await response.json())
    this.#datasetUrlPrefix = data.datasetUrlPrefix
    this.#modelCodeUrlPrefix = data.modelCodeUrlPrefix
  }
}

export const localStoragePrefixes = new LocalStoragePrefixes()
